import React from 'react';
import { Button, Confirm, Header, Form, Icon, Tab } from 'semantic-ui-react';
import Details from './historySlide/details';
import Images from './historySlide/images';
import Messages from '../Messages';
import { inlineStyle } from '../../styles/custom';
import { languages } from '../../constants';

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  panes.push({
    menuItem: 'Gestion des images',
    render: () => (
      <Tab.Pane attached={false}>
        <Images obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });

  return panes;
};

const HistorySlide = ({ obj, status, onChange, onSubmit, onDelete }) => {
  return (
    <Form>
      <Header>Slide{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Messages errors={status.errors} />
      <Form.Field>
        <Form.Input
          label="Ordre"
          type="number"
          placeholder="Ordre"
          id="order"
          value={obj.order}
          onChange={(e) => onChange(e)}
        />
      </Form.Field>
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
      <br />
      <br />
      <Form.Field>
        {status.loading ? (
          <Button type="submit" floated="left" color="red" loading>
            {' '}
            Chargement...
          </Button>
        ) : (
          <Button type="submit" floated="left" color="olive" onClick={onSubmit}>
            <Icon name="save" /> Sauvegarder
          </Button>
        )}
        {!status.isNew ? (
          <div>
            <Button
              type="submit"
              color="red"
              floated="right"
              onClick={(historySlide, data) => {
                onDelete(historySlide, { confirm: true });
              }}
            >
              <Icon name="delete" /> Suppression
            </Button>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer ce slide ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(historySlide, data) => {
          onDelete(historySlide, { confirm: null });
        }}
        onConfirm={(historySlide, data) => {
          onDelete(historySlide, { confirm: false });
        }}
        style={inlineStyle.modal}
        cancelButton="Annuler"
        confirmButton="Ok"
      />
    </Form>
  );
};

export default HistorySlide;



// WEBPACK FOOTER //
// ./src/components/form/HistorySlide.js